import React, { useEffect } from "react";

// Importing bootstrap components
import { Col, Form, Button, Table } from "react-bootstrap";

// Importing react-redux
import { batch, useDispatch, useSelector } from "react-redux";

// Importing role slices
import { setRoles, setIsDefaultSet } from "state/slices/role/roleSlice";

// Importing role mutations
import { useGetRolesQuery } from "state/slices/role/roleApiSlice";

// Import common components
import WarningAlert from "common/Alert";

const RoleViewManagement = React.memo(
  ({
    isAllowedToUpdate = false,
    isAllowedToDelete = false,
    handleCheckboxChange = () => {},
    handleEdit = () => {},
    deleteRoleManage = () => {},
    selectedRow = null,
  }) => {
    const dispatch = useDispatch();

    // Fetch roles
    const { data, refetch, isLoading } = useGetRolesQuery();

    const roles = useSelector((state) => state.role.roles);
    const isDefaultSet = useSelector((state) => state.role.isDefaultSet);

    useEffect(() => {
      if (data) {
        batch(() => {
          dispatch(setRoles(data.roles));
          dispatch(setIsDefaultSet(data.isDefaultSet));
        });
      }
    }, [data]);

    useEffect(() => {
      refetch();
    }, [roles]);

    return (
      <Col sm={12}>
        {!isDefaultSet && roles.length > 0 && (
          <WarningAlert
            icon={<i className="bi bi-exclamation-triangle-fill me-2"></i>}
            message="Warning: No default role is set. Please set it to prevent rendering wrong data."
          />
        )}
        <Table striped responsive bordered className="text-center">
          <thead>
            <tr>
              {(isAllowedToUpdate || isAllowedToDelete) && <th></th>}
              <th>S No.</th>
              <th>Role</th>
              <th>Is Team Wise</th>
              {(isAllowedToUpdate || isAllowedToDelete) && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {roles.length > 0 ? (
              roles.map((row, index) => (
                <tr key={row.id} id={row?.isDefault ? "default" : ""}>
                  {(isAllowedToUpdate || isAllowedToDelete) && (
                    <td>
                      <Form.Check
                        type="checkbox"
                        name="row"
                        value={row.id}
                        checked={selectedRow?.id === row.id}
                        onChange={(e) => handleCheckboxChange(e, row)}
                      />
                    </td>
                  )}
                  <td>{index + 1}</td>
                  <td>{row.name}</td>
                  <td>{row?.isTeamWise ? "Yes" : "No"}</td>
                  {(isAllowedToUpdate || isAllowedToDelete) && (
                    <td>
                      {isAllowedToUpdate && (
                        <Button
                          size="sm"
                          variant="outline-primary"
                          className="me-2"
                          disabled={!selectedRow || selectedRow?.id !== row.id}
                          onClick={() => handleEdit(row)}
                        >
                          <i className="bi bi-pencil-square"></i>
                        </Button>
                      )}
                      {isAllowedToDelete && (
                        <Button
                          size="sm"
                          variant="outline-danger"
                          disabled={!selectedRow || selectedRow?.id !== row.id}
                          onClick={deleteRoleManage}
                        >
                          <i className="bi bi-trash3"></i>
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr className="bg-light border text-center">
                <td colSpan={6} className="text-muted">
                  {isLoading ? "Loading Data..." : "No Data Found"}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Col>
    );
  }
);

export default RoleViewManagement;
